import MemoEntity from '../entities/Memo';

export type State = MemoEntity[];

const initialState: State = [];

const Memo = (state: State = initialState, action: any) => {
  switch (action.type) {
    case 'SUCCESS_READ_MEMO':
      return [...state, action.memo].filter(
        (memo, index, self) => self.map(m => m.id).indexOf(memo.id) === index
      );

    case 'SUCCESS_READ_MEMOS_RELATED':
      return [...state, ...action.memos].filter(
        (memo, index, self) => self.map(m => m.id).indexOf(memo.id) === index
      );

    case 'TRUNCATE_MEMOS':
      return [];

    case 'SUCCESS_READ_MEMOS_BY_GROUP':
    case 'SUCCESS_READ_MEMOS_BY_DEADLINE':
      return [...state, ...action.memos].filter(
        (memo, index, self) => self.map(m => m.id).indexOf(memo.id) === index
      );

    case 'SUCCESS_READ_MEMOS_SEARCH':
      return [...state, ...action.memos].filter(
        (memo, index, self) => self.map(m => m.id).indexOf(memo.id) === index
      );

    case 'SUCCESS_READ_MEMOS_DIFF':
      const memosChanged = state.map(memo =>
        action.memos.map((m: MemoEntity) => m.id).includes(memo.id)
          ? action.memos.find((m: MemoEntity) => m.id === memo.id)
          : memo
      );

      const memosToAdd = action.memos.filter(
        (memo: MemoEntity) => !state.map(m => m.id).includes(memo.id)
      );

      return [...memosChanged, ...memosToAdd];

    case 'SUCCESS_CREATE_MEMO':
      return [...state, action.memo];

    case 'SUCCESS_UPDATE_MEMO':
      return state.map(memo => {
        return memo.id === action.memo.id ? action.memo : memo;
      });

    case 'SUCCESS_DESTROY_MEMO':
      return state.filter(memo => memo.id !== action.memo.id);
  }

  return state;
};

export default Memo;



// WEBPACK FOOTER //
// ./src/reducers/Memo.ts